<template>
  <div class="show-property">
    <a-form layout="vertical" v-if="currentLivingConditionObject !== null">
      <a-row v-bind:gutter="16">
        <a-col v-bind:span="12">
          <a-form-item label="Kosten inwonend p/m">
            <a-input
                v-bind:value="currentLivingConditionObject.rental_costs"
                v-on:input="event => currentLivingConditionObject.rental_costs = event.target.value"
                v-on:change="onChange"
                type="number"
                prefix="€"
                style="display:block;"
            />
          </a-form-item>
        </a-col>
        <a-col v-bind:span="12">
          <a-form-item label="Overige kosten p/m">
            <a-input
                v-bind:value="currentLivingConditionObject.other_costs"
                v-on:input="event => currentLivingConditionObject.other_costs = event.target.value"
                v-on:change="onChange"
                type="number"
                prefix="€"
                style="display:block;"
            />
          </a-form-item>
        </a-col>
      </a-row>
    </a-form>
  </div>
</template>

<script>
import customerCurrentLivingConditionApi from '~/api/customer_current_living_condition';

export default {
  name: "EditResidentComponent",
  components: {},
  props: {
    value: {
      required: true,
      type: Object
    },
    autoSave: {
      type: Boolean,
      required: false,
      default: false
    },
  },
  data() {
    return {
      currentLivingConditionObject: null,
      persistTimeout: 0,
    }
  },
  computed: {},
  mounted() {
    this.currentLivingConditionObject = this.value;
  },
  methods: {
    onChange() {
      this.$emit('input', this.currentLivingConditionObject);
      this.$emit('change', this.currentLivingConditionObject);

      if (this.autoSave) {
        this.save();
      }
    },
    save() {
      clearTimeout(this.persistTimeout)

      this.persistTimeout = setTimeout(() => {
        customerCurrentLivingConditionApi.update(this.currentLivingConditionObject).then(() => {
          this.$emit('save', this.currentLivingConditionObject);
        }).catch((error) => {
          this.$message.error('Er ging iets fout tijdens het opslaan');
          this.$emit('error', error);
        });
      }, 500)
    }
  },
}
</script>
<style scoped>
</style>
